import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import ContentBlogs from "./blogs";
import ContentVideos from "./videos";
import useAccessLevels from "../../../../hooks/use-access-levels";


const ContentViews = () => {
    const location = useLocation()
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Listens to the changes in location.pathname and with each change:
     * if the url is the same as content.base, then changes it to the blogs.list.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.content.base, exact: true})) {
            if (operatorAccessLevels.packages.base.contentVideos) {
                history.replace(routes.content.videos.list);
            } else if (operatorAccessLevels.packages.base.contentBlogs) {
                history.replace(routes.content.blogs.list);
            } else {
                history.replace(routes.content.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.base.contentBlogs, operatorAccessLevels.packages.base.contentVideos])

    return (
        <Switch>
            <Route path={routes.content.base} exact/>
            {
                operatorAccessLevels.packages.base.contentVideos &&
                <Route
                    path={[
                        routes.content.videos.base,
                        routes.content.videos.single,
                        routes.content.videos.list
                    ]}
                    exact>
                    <ContentVideos/>
                </Route>
            }
            {
                operatorAccessLevels.packages.base.contentBlogs &&
                <Route path={[
                    routes.content.blogs.base,
                    routes.content.blogs.single,
                    routes.content.blogs.list
                ]} exact>
                    <ContentBlogs/>
                </Route>
            }
            <Redirect to={routes.content.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default ContentViews;
